import { User } from '.';

export interface RegionLead {
  programRegionLeadId: number;
  programId: number;
  regionId: number;
  emailAddress: string;
  user?: User;
  isPrimary: boolean;
}

export function blankRegionLead(): RegionLead {
  return {
    programRegionLeadId: 0,
    programId: 0,
    regionId: 0,
    emailAddress: '',
    isPrimary: false,
  }
}
